import { Download, FileText, Lightning, Lock } from "@phosphor-icons/react";
import { motion } from "framer-motion";

const steps = [
  {
    icon: FileText,
    title: "Create Your CV",
    description: "Choose a template and fill in your details.",
  },
  {
    icon: Lightning,
    title: "Choose a Plan",
    description: "Select one-time download or monthly access.",
  },
  {
    icon: Lock,
    title: "Secure Checkout",
    description: "Pay using M-Pesa, card, bank transfer, or mobile money via Pesapal.",
  },
  {
    icon: Download,
    title: "Download Instantly",
    description: "Access your CV immediately after payment confirmation.",
  },
];

export const HowItWorksSection = () => {
  return (
    <section id="how-it-works" className="relative bg-background py-24 sm:py-32">
      <div className="container">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-bold tracking-tight text-dark-gray sm:text-5xl">
            How It Works
          </h2>
          <p className="mt-6 text-lg leading-8 text-medium-gray">
            Get your professional CV in 4 simple steps.
          </p>
        </div>

        <div className="mx-auto mt-16 max-w-5xl">
          <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
            {steps.map((step, index) => {
              const Icon = step.icon;
              return (
                <motion.div
                  key={index}
                  viewport={{ once: true }}
                  initial={{ opacity: 0, y: 50 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="flex flex-col items-center text-center"
                >
                  <div className="mb-4 flex size-16 items-center justify-center">
                    <Icon className="size-12 text-accent" weight="regular" />
                  </div>
                  <h3 className="mb-2 text-lg font-semibold text-dark-gray">{step.title}</h3>
                  <p className="text-sm leading-relaxed text-medium-gray">{step.description}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
